export default __webpack_public_path__ + "static/media/g10.0df807a7.svg";